module.exports = __webpack_public_path__ + "img/logo.850c054c.png";